import PropTypes from 'prop-types';
import {I18n, Translate} from 'react-redux-i18n';
import {Tooltip} from '@material-ui/core';
import {COUNTRY} from 'front-onceforall-core/dist/utils/country';
import {stringUtils} from 'front-onceforall-core';
import {projectType} from '../../utils/constant';

function ProjectTypeForm(props) {
  let createStandardProjectButton = (
    <button
      type="button"
      className="large primary"
      data-id="standard-button"
      onClick={() => props.onSelectType(projectType.STANDARD)}
      disabled={props.standardProjectCredits <= 0}
      style={props.standardProjectCredits <= 0 ? {pointerEvents: 'none'} : {}}
    >
      <Translate value="project.typeForm.choose"/>
    </button>
  );
  if (props.standardProjectCredits <= 0) {
    createStandardProjectButton = (<Tooltip
      data-id="create-standard-project-tooltip"
      title={<Translate value="project.create.projectCreditsTooltip"/>}
    >
      <span>{createStandardProjectButton}</span>
    </Tooltip>);
  }

  let createNominativeProjectButton = (
    <button
      type="button"
      className="large primary"
      data-id="nominative-button"
      disabled={props.nominativeProjectCredits <= 0}
      style={props.nominativeProjectCredits <= 0 ? {pointerEvents: 'none'} : {}}
      onClick={() => props.onSelectType(projectType.NOMINATIVE)}
    >
      <Translate value="project.typeForm.choose"/>
    </button>
  );
  if (props.nominativeProjectCredits <= 0) {
    createNominativeProjectButton = (<Tooltip
      data-id="create-nominative-project-tooltip"
      title={<Translate value="project.create.projectCreditsTooltip"/>}
    >
      <span>{createNominativeProjectButton}</span>
    </Tooltip>);
  }

  return (
    <>
      <p>
        <Translate value="project.typeForm.notice"/>
      </p>
      <div className="row">
        <div
          className="col-lg-6"
          data-id="standard-project"
        >
          <div
            className="box flex-container column space-between"
            style={{height: '100%'}}
          >
            <div className="flex-container column">
              <h3 className="active">
                <Translate value="project.type.STANDARD"/>
              </h3>
              <p><Translate value="project.typeForm.STANDARD.intro"/></p>
              <ul className="mb-5 mt-0">
                <li><Translate value="project.typeForm.STANDARD.firstPoint"/></li>
                <li><Translate value="project.typeForm.STANDARD.secondPoint"/></li>
                <li><Translate value="project.typeForm.STANDARD.thirdPoint"/></li>
              </ul>
            </div>
            <div className="inline-container space-between">
              {createStandardProjectButton}
              <span>{stringUtils.getStrongs(I18n.t('project.creditsStandard', {count: props.standardProjectCredits}))}</span>
            </div>
          </div>
        </div>

        {props.organisation.country === COUNTRY.FRANCE &&
        <div
          className="col-lg-6"
          data-id="nominative-project"
        >
          <div
            className="box flex-container column space-between"
            style={{height: '100%'}}
          >
            <div className="flex-container column">
              <h3 className="active">
                <Translate value="project.type.NOMINATIVE"/>
              </h3>
              <p><Translate value="project.typeForm.NOMINATIVE.intro"/></p>
              <ul className="mb-5 mt-0">
                <li><Translate value="project.typeForm.NOMINATIVE.firstPoint"/></li>
                <li><Translate value="project.typeForm.NOMINATIVE.secondPoint"/></li>
                <li><Translate value="project.typeForm.NOMINATIVE.thirdPoint"/></li>
                <li><Translate value="project.typeForm.NOMINATIVE.fourthPoint"/></li>
                <li><Translate value="project.typeForm.NOMINATIVE.fifthPoint"/></li>
              </ul>
            </div>
            <div className="inline-container space-between">
              {createNominativeProjectButton}
              <span>{stringUtils.getStrongs(I18n.t('project.creditsNominative', {count: props.nominativeProjectCredits}))}</span>
            </div>
          </div>
        </div>
        }
      </div>
    </>
  );
}

ProjectTypeForm.propTypes = {
  onSelectType: PropTypes.func.isRequired,
  organisation: PropTypes.object.isRequired,
  standardProjectCredits: PropTypes.number.isRequired,
  nominativeProjectCredits: PropTypes.number.isRequired
};

export default ProjectTypeForm;
